var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExxonBadgeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 306,
    height: 371,
    viewBox: "0 0 306 371",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.a,.d,.e,.f{stroke:#545459;}.a,.e{stroke-width:7px;}.b,.k{fill:#545459;}.c{fill:#00518d;}.d,.e,.f,.g,.j{fill:none;}.d{stroke-width:14px;}.e,.f,.g{stroke-linecap:round;}.f,.g{stroke-linejoin:round;stroke-miterlimit:10;}.f{stroke-width:3px;}.h{fill:#ed1e24;}.i,.k{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-531 -173)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(531 293)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 167,
    height: 218,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 3.5,
    y: 3.5,
    width: 160,
    height: 211,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 77,
    height: 6,
    rx: 3,
    transform: "translate(549 418)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 111,
    height: 6,
    rx: 3,
    transform: "translate(549 430)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H167a0,0,0,0,1,0,0V18a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z",
    transform: "translate(531 485)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34,
    height: 60,
    rx: 4,
    transform: "translate(597.5 260.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(578 173)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 36.5,
    cy: 36.5,
    r: 36.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 36.5,
    cy: 36.5,
    r: 29.5
  })), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(606 271)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y2: 29.5,
    transform: "translate(614.5 244.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M51,50.939a6.406,6.406,0,0,0-4.413-6.016A58.767,58.767,0,0,0,27.5,42,58.767,58.767,0,0,0,8.413,44.923,6.406,6.406,0,0,0,4,50.939V58H51Z",
    transform: "translate(546.5 347.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(544 355)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M30,28h0c-6.627,0-12-5.093-12-11.375v-3.25C18,7.093,23.373,2,30,2h0c6.627,0,12,5.093,12,11.375v3.25C42,22.907,36.627,28,30,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M 30 25 C 34.96262359619141 25 39 21.24298858642578 39 16.625 L 39 13.375 C 39 8.757011413574219 34.96262359619141 5 30 5 C 25.03737831115723 5 21 8.757011413574219 21 13.375 L 21 16.625 C 21 21.24298858642578 25.03737831115723 25 30 25 M 30 28 C 23.37257766723633 28 18 22.9072437286377 18 16.625 L 18 13.375 C 18 7.092755317687988 23.37257766723633 2 30 2 C 36.62743377685547 2 42 7.092755317687988 42 13.375 L 42 16.625 C 42 22.9072437286377 36.62743377685547 28 30 28 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(670 326)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "i",
    width: 167,
    height: 218,
    rx: 8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "j",
    x: 3.5,
    y: 3.5,
    width: 160,
    height: 211,
    rx: 4.5
  })), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 77,
    height: 6,
    rx: 3,
    transform: "translate(688 451)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 111,
    height: 6,
    rx: 3,
    transform: "translate(688 463)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M0,0H167a0,0,0,0,1,0,0V18a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8V0A0,0,0,0,1,0,0Z",
    transform: "translate(670 518)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 34,
    height: 60,
    rx: 4,
    transform: "translate(736.5 293.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "d",
    transform: "translate(717 206)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "i",
    cx: 36.5,
    cy: 36.5,
    r: 36.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "j",
    cx: 36.5,
    cy: 36.5,
    r: 29.5
  })), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(745 304)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "e",
    y2: 29.5,
    transform: "translate(753.5 277.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M51,50.939a6.406,6.406,0,0,0-4.413-6.016A58.767,58.767,0,0,0,27.5,42,58.767,58.767,0,0,0,8.413,44.923,6.406,6.406,0,0,0,4,50.939V58H51Z",
    transform: "translate(685.5 380.5)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(683 388)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M30,28h0c-6.627,0-12-5.093-12-11.375v-3.25C18,7.093,23.373,2,30,2h0c6.627,0,12,5.093,12,11.375v3.25C42,22.907,36.627,28,30,28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M 30 25 C 34.96262359619141 25 39 21.24298858642578 39 16.625 L 39 13.375 C 39 8.757011413574219 34.96262359619141 5 30 5 C 25.03737831115723 5 21 8.757011413574219 21 13.375 L 21 16.625 C 21 21.24298858642578 25.03737831115723 25 30 25 M 30 28 C 23.37257766723633 28 18 22.9072437286377 18 16.625 L 18 13.375 C 18 7.092755317687988 23.37257766723633 2 30 2 C 36.62743377685547 2 42 7.092755317687988 42 13.375 L 42 16.625 C 42 22.9072437286377 36.62743377685547 28 30 28 Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExxonBadgeIcon);
export default __webpack_public_path__ + "static/media/exxon-badge-icon.83f9f53b20a0b77295ce16a2ef09825a.svg";
export { ForwardRef as ReactComponent };